<template>
  <div id="printMChat" style="margin:0 auto; width:980px;border:0px solid #E8E8EC;">
    <span v-show="false" ref="data"></span>
    <div class="page content">
      <div class="title">婴幼儿社会功能筛查</div>
      <table class="container" cellspacing="0" cellpadding="0" border="0" style="border:none;text-align: left;">
        <tbody>
          <tr style="line-height: 25px;border:none;"><td style="border:none;">测评机构： {{form.institution_name}}</td></tr>
          <tr style="line-height: 25px;border:none;"><td style="border:none;">测评时间： {{form.medicalDate}}</td></tr>
          <tr style="line-height: 25px;border:none;"><td style="border:none;">测评内容： 婴幼儿社区功能筛查</td></tr>
        </tbody>
      </table>

      <table class="container" cellspacing="0" cellpadding="0" border="0" style="border:none;text-align: center;margin-top: 10px;margin-bottom: 10px;">
        <tbody>
          <tr style="background-color: #ddd;height:5px;line-height:35px;font-size:18px;font-weight: 600;">
            <td><p>第一部分 受测试者基本信息</p></td>
          </tr>
        </tbody>
      </table>

      <table class="container" cellspacing="0" cellpadding="0" border="0" style="border:none;text-align: left;">
        <tbody>
          <tr style="line-height: 25px;border:none;"><td colspan="1" style="border:none;">姓名： </td><td colspan="7" style="border:none;font-weight: 600;">{{form.name}}</td></tr>
          <tr style="line-height: 25px;border:none;"><td colspan="1" style="border:none;">性别： </td><td colspan="7" style="border:none;font-weight: 600;">{{form.gender === 1 ? "男" : "女"}}</td></tr>
          <tr style="line-height: 25px;border:none;"><td colspan="1" style="border:none;">年龄： </td><td colspan="7" style="border:none;font-weight: 600;">{{(form.age + "").length > 0 ? form.age + "岁" : ""}}</td></tr>
          <tr style="line-height: 25px;border:none;"><td colspan="1" style="border:none;">出生日期： </td><td colspan="7" style="border:none;font-weight: 600;">{{form.birthday}}</td></tr>
          <tr style="line-height: 25px;border:none;"><td colspan="1" style="border:none;">与儿童关系： </td><td colspan="7" style="border:none;font-weight: 600;">{{form.relation}}</td></tr>
        </tbody>
      </table>

      <table class="header" cellspacing="0" cellpadding="0" border="0" style="text-align: center;margin-top: 15px;" >
        <tbody>
          <tr style="background-color: #ddd;height:35px;line-height:35px;"><td colspan="8" style="font-size: 18px;font-weight: 600;">第二部分 结果信息</td></tr>
          <tr style="background-color: #9e9e9e1f;"><td>题号</td><td>结果</td><td>题号</td><td>结果</td><td>题号</td><td>结果</td><td>题号</td><td>结果</td></tr>
          <tr style="line-height: 30px;"><td>1</td><td>{{problems[0]==='1'?"是":"否"}}</td><td>7</td><td>{{problems[6]==='1'?"是":"否"}}</td><td>13</td><td>{{problems[12]==='1'?"是":"否"}}</td><td>19</td><td>{{problems[18]==='1'?"是":"否"}}</td></tr>
          <tr style="line-height: 30px;"><td>2</td><td>{{problems[1]==='1'?"是":"否"}}</td><td>8</td><td>{{problems[7]==='1'?"是":"否"}}</td><td>14</td><td>{{problems[13]==='1'?"是":"否"}}</td><td>20</td><td>{{problems[19]==='1'?"是":"否"}}</td></tr>
          <tr style="line-height: 30px;"><td>3</td><td>{{problems[2]==='1'?"是":"否"}}</td><td>9</td><td>{{problems[8]==='1'?"是":"否"}}</td><td>15</td><td>{{problems[14]==='1'?"是":"否"}}</td><td></td><td></td></tr>
          <tr style="line-height: 30px;"><td>4</td><td>{{problems[3]==='1'?"是":"否"}}</td><td>10</td><td>{{problems[9]==='1'?"是":"否"}}</td><td>16</td><td>{{problems[15]==='1'?"是":"否"}}</td><td></td><td></td></tr>
          <tr style="line-height: 30px;"><td>5</td><td>{{problems[4]==='1'?"是":"否"}}</td><td>11</td><td>{{problems[10]==='1'?"是":"否"}}</td><td>17</td><td>{{problems[16]==='1'?"是":"否"}}</td><td></td><td></td></tr>
          <tr style="line-height: 30px;"><td>6</td><td>{{problems[5]==='1'?"是":"否"}}</td><td>12</td><td>{{problems[11]==='1'?"是":"否"}}</td><td>18</td><td>{{problems[17]==='1'?"是":"否"}}</td><td></td><td></td></tr>
        </tbody>
      </table>

      <table cellspacing="2" cellpadding="2" border="3" style="text-align: center;margin-top: 15px;" >
        <tbody>
          <tr style="background-color: #ddd;height:35px;line-height:35px;"><td colspan="8" style="font-size: 18px;font-weight: 600;">第三部分 结论信息</td></tr>
          <tr style="line-height: 30px;"><td colspan="2" style="width: 30px;">结论类型</td><td colspan="6">总分</td></tr>
          <tr style="line-height: 30px;"><td colspan="2" style="width: 30px;">测评得分</td><td colspan="6">{{form.totalScore}}</td></tr>
          <tr style="line-height: 30px;">
            <td colspan="2" style="width: 30px;">得分说明</td><td colspan="6" style="text-align:left;flex-wrap: wrap;justify-content: flex-start;">
              量表项目11、18、20、22回答为“3分”，其余项目回答“0分”视为筛查不通过;若项目2、7、9、13、14、15中有两项或以上为“3分”，或者在全部项目中有三个项目或以上为“3分”，视为存在孤独症或其他发育障碍的风险;总分>17分视为筛查不通过。
            </td>
          </tr>
          <tr style="line-height: 30px;"><td colspan="2" style="width: 33px;">测评结果</td><td colspan="6" style="text-align:left;flex-wrap: wrap;justify-content: flex-start;" v-html="form.result ? form.result : ''"></td></tr>
          <tr style="line-height: 30px;"><td colspan="2" style="width: 33px;">评分说明</td><td colspan="6" style="text-align:left;flex-wrap: wrap;justify-content: flex-start;">{{form.scoreRemark ? form.scoreRemark : ""}}</td></tr>
        </tbody>
      </table>

    </div>
  </div>
</template>
<script>
import {_print} from "@/services/autism/mChat";
export default {
  name: "printMChat",
  data() {
    return {
      id:"",
      institutionId:"",
      form:{
        id:"",
        medicalDate:"",
        institutionId:"",
        institutionName:"",
        subordinate:"",
        kindergartenName:"",
        name:"",
        gender:"",
        age:"",
        birthday:"",
        contactPerson:"",
        cardNum:"",
        relation:"",
        phone:"",
        address:"",
        currentAddress:"",
        problem:"",
        otherQuestions:"",
        totalScore:"",
        result:"",
        scoreRemark:"",
        remark:"",
      },
      problems:[]
    };
  },
  mounted() {
    this.institutionId = this.$route.query.institutionId;
    this.id = this.$route.query.id;
    _print({institutionId: this.institutionId, id: this.id}).then(res => {
      if (res.errcode !== 1) {
        this.$Message.error(res.errmsg);
        return;
      }
      this.form = res.data
      this.form.institution_name = this.form.institutionName + (this.form.subordinate&&this.form.subordinate.length > 0 ? "-" + this.form.subordinate : "")
      this.problems = this.form.problem.split(",");
    })
  },
  methods: {

  }
};
</script>
<style lang="postcss" scoped>
body,html{margin:0;padding:0;font-size:22px;}
.page {width: 100px;margin: 0 auto;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always}
.content {width: 210mm;height: 297mm;text-align: center;}
.title {margin-top: 30px;margin-bottom: 30px;font-size: 30px;text-align: center;}
table {border-collapse:collapse;border:none;font-size: 15px;width: 100%;}
table, th, td {border: 1px solid #ddd;}
th, td {width: 100px;}
table.header, table.header tr, table.header td {border: 1px solid #ddd;}
</style>
